var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapAnalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_analysis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.334 17.5H1.667v-15h1.667v13.333H5v-1.666h3.334v1.666H10v-2.5h3.334v2.5H15v-1.666h3.334V17.5ZM15 11.667h3.334v1.666H15v-1.666ZM10 5h3.334v2.5H10V5Zm3.334 7.5H10V8.333h3.334V12.5ZM5 8.333h3.334V10H5V8.333Zm3.334 5H5v-2.5h3.334v2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAnalysis);
export default __webpack_public_path__ + "static/media/map_analysis.9e6d1bbe9470dab2a9e55b1cc6f117cc.svg";
export { ForwardRef as ReactComponent };